export const APIBaseURL = import.meta.env.VITE_API_BASE_URL;
export const WwwBaseURL = import.meta.env.VITE_WWW_BASE_URL;
export const BffBaseURL = import.meta.env.VITE_BFF_BASE_URL;
export const GoogleMapsKey = import.meta.env.VITE_GOOGLE_MAPS_KEY;
export const VersionProduct = import.meta.env.VITE_VERSION_PRODUCT;
export const VersionStream = import.meta.env.VITE_VERSION_STREAM;
export const WwwLoginURL = `${BffBaseURL}/auth0/login`;
export const WwwAppURL = `${WwwBaseURL}/app`;
export const HomepageURL = import.meta.env.VITE_HOMEPAGE_URL;
export const PrivacyURL = `${HomepageURL}/privacy.html`;
export const CreditsURL = `${HomepageURL}/credits.html`;